/**
 * Location Edit - video gallery module
 *
 * Implements youtube video gallery module
 *
 * This videogallery.js only handles the current use case, custom video gallery field.
 * It does not support alternate profile now since custom field are primary only.
 * But alternate profile can easily be supported by adding a toggling method,
 * since the display data is already loaded in the constructor.
 *
 * @author Naiqiao Liang (nliang@yext.com)
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.VideoList');
goog.provide('yext.location.VideoList.Video');
goog.provide('yext.location.VideoGalleryView');

goog.require('yext');
goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.usage');
goog.require('yext.dam.labels.view');
goog.require('yext.textfield');
goog.require('yext.videochooser');
goog.require('yext.youtube');
goog.require('yext.utils.youtube');
goog.require('yext.location.helpers');

/**
 * View model that serializes to VideoListView
 *
 * @param {!jQuery} $ctx The module context
 * @param {function()} cb This function will be called after loading YouTube data
 * @constructor
 */
yext.location.VideoList = function($ctx, cb) {
  this.$editTemplate = $($ctx.find('.js-video-gallery-edit-template').html());
  this.displayTemplate = $ctx.find('.js-video-display-template').html();
  this.fieldId = $ctx.data('fieldId');

  var data = $ctx.data('videoData');

  this.numElided = data.numElided || 0;
  this.displayNumElided = data.displayNumElided || 0;
  this.timestamp = data.timestamp || 0;

  this.fetchVideos(data, cb);
};

/**
 * Called when an asset is chosen
 *
 * @param {!Object} asset
 * @param {function()} cb This function will be called after loading YouTube data
 */
yext.location.VideoList.prototype.addVideo = function(asset, cb) {
  var self = this;
  var data = {
    url: asset.videoinfo.url,
    description: {
      value: asset.description || '',
    },
  };
  this.fetchVideosFromYoutube([data.url], function(videoinfo) {
    var video = self.newVideo(data, videoinfo[0]);
    self.videos.push(video);
    cb(video);
    self.message('updated');
  });
};

/**
 * @return boolean True if video list is empty
 */
yext.location.VideoList.prototype.isEmpty = function() {
  return this.videos.length === 0;
};

/**
 * @return boolean True if display video list is empty
 */
yext.location.VideoList.prototype.isDisplayEmpty = function() {
  return this.displayVideos.length === 0;
};

/**
 * @return boolean True if one of the display videos is indeterminate
 */
yext.location.VideoList.prototype.getDisplayIndeterminate = function() {
  return this.hasIndeterminate(this.displayVideos);
};

/**
 * @return boolean True if one of the videos is indeterminate
 */
yext.location.VideoList.prototype.getIndeterminate = function() {
  return this.hasIndeterminate(this.videos);
};

/**
 * @param {!Array.<yext.location.VideoList.Video|DisplayVideo>} List of videos to check
 * @return boolean True if one of the videos is indeterminate
 */
yext.location.VideoList.prototype.hasIndeterminate = function(videos) {
  for (var i = 0; i < videos.length; i++) {
    if (videos[i].video.indeterminate) {
      return true;
    }
  }
  return false;
};

/**
 * Get the video data as a model that deserializes to VideoListView java class
 */
yext.location.VideoList.prototype.getData = function() {
  var videos = [];
  var displayVideos = [];

  for (var i = 0; i < this.videos.length; i++) {
    videos.push(this.videos[i].getData());
  }

  for (var i = 0; i < this.displayVideos.length; i++) {
    displayVideos.push(this.displayVideos[i].getData());
  }

  return {
    numElided: this.numElided,
    displayNumElided: this.displayNumElided,
    timestamp: this.timestamp,
    videos: videos,
    displayVideos: displayVideos,
  };
};

/**
 * Set the state of the field
 *
 * @param {!Object} Plain object version of this field
 * @param {function()} cb This function will be called after loading YouTube data
 */
yext.location.VideoList.prototype.set = function(data, cb) {
  this.numElided = data.numElided;
  this.displayNumElided = data.displayNumElided;
  this.timestamp = data.timestamp;

  this.fetchVideos(data, cb);
};

/**
 * Send a message with the instance as context
 * @param {string} message
 */
yext.location.VideoList.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Fetch video info from youtube and set the videos and displayVideo lists
 *
 * @param {!Object} Plain object version of this field
 * @param {function()} cb This function will be called after loading YouTube data
 */
yext.location.VideoList.prototype.fetchVideos = function(data, cb) {
  var self = this;

  // Nothing to do
  if (data.displayVideos.length === 0) {
    this.videos = [];
    this.displayVideos = [];
    if (yext.isFunction(cb)) {
      cb(this);
    }
    return;
  }

  // Get all urls (display should have all in all cases)
  var urls = data.displayVideos.map(function(video) {
    return video.url;
  });

  // Fetch YouTube data
  this.fetchVideosFromYoutube(urls, function(videoinfo) {
    var infoByUrl = {};
    for (var i = 0; i < videoinfo.length; i++) {
      infoByUrl[videoinfo[i].url] = videoinfo[i];
    }

    self.videos = data.videos.map(function(video) {
      return self.newVideo(video, infoByUrl[video.url]);
    });

    self.displayVideos = data.displayVideos.map(function(video) {
      return self.newDisplayVideo(video, infoByUrl[video.url]);
    });

    if (yext.isFunction(cb)) {
      cb(self);
    }
  });
};

/**
 * @param {!Object} data Plain video data
 * @param {!Object} info YouTube video data
 */
yext.location.VideoList.prototype.newVideo = function(data, info) {
  var self = this;
  var html = this.generateVideoHtml(data, info);

  var $element = this.$editTemplate.clone();
  $element.find('.js-video-gallery-display').html(html);

  var video = new yext.location.VideoList.Video($element, data, info, this.fieldId);

  $(video).on('updated', function() {
    self.message('updated');
  });

  $(video).on('delete', function() {
    var index = self.videos.indexOf(video);
    if (index !== -1) {
      self.videos.splice(index, 1);
      self.message('updated');
    }
  });

  return video;
};

/**
 * @param {!Object} data Plain video data
 * @param {!Object} info YouTube video data
 */
yext.location.VideoList.prototype.newDisplayVideo = function(video, info) {
  var $element = $(this.generateVideoHtml(video, info));
  return new yext.location.VideoList.DisplayVideo($element, video, info);
};

/**
 * Generate video html from video template
 *
 * @param video {VideoGallery.Video} Video model
 * @param videoinfo {!Object} Video info (url, id ...) from youtube
 */
yext.location.VideoList.prototype.generateVideoHtml = function(video, videoinfo) {
  var html = '';
  if (videoinfo) {
    html = yext.utils.youtube.fixupVideoTemplate(this.displayTemplate, videoinfo);
  } else {
    // TODO(mattjs) Template this in a cleaner way
    html += '<div class="link remove remove-item js-remove-video">[X]</div>';
    html += yext.location.helpers.errorMessage(yext.msg(
      'There was an error retrieving video details from Youtube.' +
        ' The <a href="{0}">video</a> may be private or unavailable.',
      video.url));
  }
  return html;
};

/**
 * Get metadata from youtube so video preview can be rendered
 *
 * @param {!Array.<string>} url video url
 * @param {function()} cb Callback for when finished
 */
yext.location.VideoList.prototype.fetchVideosFromYoutube = function(urls, cb) {
  var self = this;
  var youtubeIds = [];
  for (var i = 0; i < urls.length; i++) {
    youtubeIds.push(yext.youtube.parseIdFromUrl(urls[i]));
  }

  yext.youtube.getVideosDetails([youtubeIds], function(videos) {
    cb(videos);
  }, function() {
    // Error and we have no idea why
    self.showError();
    cb();
  });
};

/**
 * @param {!jQuery} $element The context for this video
 * @param {!Object} data Plain video data
 * @param {!Object} info YouTube video data
 * @param {!Object} parentFieldId field id for parent wrapper
 * @constructor
 */
yext.location.VideoList.Video = function($element, video, info, parentFieldId) {
  this.$element = $element;
  this.video = video;
  this.info = info;
  this.parentFieldId = parentFieldId;
  this.description = this.bindTextField();

  this.render();
  this.bind();
};

/**
 * @return Data for this video. Deserializes to Video.java
 */
yext.location.VideoList.Video.prototype.getData = function() {
  return {
    url: this.video.url,
    indeterminate: this.video.indeterminate,
    description: this.description.coreData(),
  };
};

/**
 * Render some UI changes to the field based upon its state
 */
yext.location.VideoList.Video.prototype.render = function() {
  this.$element.find('input[type=checkbox]').prop('indeterminate', this.video.indeterminate);
  this.$element.data('id', yext.youtube.parseIdFromUrl(this.video.url));
};

/**
 * Add some UI bindings to the video
 */
yext.location.VideoList.Video.prototype.bind = function() {
  var self = this;
  var $checkbox = this.$element.find('input[type=checkbox]');
  $checkbox.on('change', function() {
    if (self.video.indeterminate) { // Force checked to true when starting indeterminate
      $checkbox.prop('checked', true);
    }
    self.video.indeterminate = false;
    self.message('updated');
  });

  this.$element.find('.js-remove-video').on('click', function(e) {
    self.$element.remove();
    self.message('delete');
  });
};

/**
 * Bind the video description module
 */
yext.location.VideoList.Video.prototype.bindTextField = function() {
  var self = this;
  var description = yext.textfield.createWithUsageType(this.$element.find('.js-text-field'), self.parentFieldId);

  if (this.video.description) {
    description.set(this.video.description);
  }
  $(description).on('update.textField', function() {
    self.message('updated');
  });
  return description;
};

/**
 * Send a message with the instance as context
 * @param {string} message
 */
yext.location.VideoList.Video.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * @param {!jQuery} $element The context for this video
 * @param {!Object} data Plain video data
 * @param {!Object} info YouTube video data
 * @constructor
 */
yext.location.VideoList.DisplayVideo = function($element, video, info) {
  this.$element = $element;
  this.video = video;
  this.info = info;

  // No deletes in display mode
  this.$element.find('.js-remove-video').remove();
};

/**
 * @return Details about the display state to be stored
 */
yext.location.VideoList.DisplayVideo.prototype.getData = function() {
  return {
    url: this.video.url,
    indeterminate: this.video.indeterminate,
  };
};

/**
 * Video view controller
 *
 * @param {!jQuery} $element A parent container for the edit/display elements
 * @param {string} context the html tag containing the $element
 * @param {LocationField} locationField
 * @constructor
 */
yext.location.VideoGalleryView = function($element, context, locationField) {
  this.$element = $element;
  this.$row = $element.closest(context);
  this.$edit = $element.find('.js-video-gallery-edit');
  this.$display = $element.find('.js-video-list-display');
  this.$displayGrid = $element.find('.js-video-grid');
  this.$editWrapper = $element.find('.js-video-gallery-edit-wrapper');
  this.$videoList = this.$edit.find('.js-video-list');
  this.$fieldData = this.$edit.find('.js-field-data');
  this.$selectAll = this.$edit.find('.js-gallery-edit-all');

  this.locationField = locationField;
  this.fieldName = this.$edit.find('[name="field"]').val();

  var self = this;
  new yext.location.VideoList($element, function(videoList) {
    self.videoList = videoList;
    self.onReady();
  });
};

/**
 * This initialization block runs after YouTube data has loaded
 */
yext.location.VideoGalleryView.prototype.onReady = function() {
  this.saveValue();
  this.renderDisplay();
  this.renderEdit();
  this.setFieldData();
  this.bindAddVideo();
  this.bindUpdateVideos();
  this.bindSorting();
  this.bindSelectAll();
  this.bindClearAllElided();
};

/**
 * Renders video gallery view display mode.
 */
yext.location.VideoGalleryView.prototype.renderDisplay = function() {
  var error = false;

  this.$displayGrid.empty().toggle(this.videoList.displayVideos.length > 0);
  this.$element.find('.js-video-gallery-loading').hide();
  this.$display.find('.js-add-video').hide();
  this.$display.find('.js-video-various').hide();

  if (this.videoList.getDisplayIndeterminate()) {
    this.$display.find('.js-video-various').show();
  } else if (this.videoList.displayVideos.length > 0) {
    for (var i = 0; i < this.videoList.displayVideos.length; i++) {
      var video = this.videoList.displayVideos[i];
      this.$displayGrid.append(video.$element);
      if (!video.info) {
        error = true;
      }
    }

    // Render error when videos fail to load
    if (error) {
      this.$displayGrid.empty().append(
        yext.location.helpers.errorMessage(yext.msg('One or more of the videos failed to load')));
    }
  } else {
    this.$display.find('.js-add-video').show();
  }
};

/**
 * Renders video gallery view edit mode.
 */
yext.location.VideoGalleryView.prototype.renderEdit = function() {
  var self = this;
  this.$editWrapper.empty();
  this.$selectAll
    .prop('checked', true)
    .prop('indeterminate', this.videoList.getIndeterminate());

  this.renderOnUpdate();
  this.$edit.find('.js-video-gallery-loading').hide();

  // render edit views
  for (var i = 0; i < this.videoList.videos.length; i++) {
    var video = this.videoList.videos[i];
    this.$editWrapper.append(video.$element);
  }
};

/**
 * Any render actions that should happen during an update
 */
yext.location.VideoGalleryView.prototype.renderOnUpdate = function() {
  // render count
  var total = yext.msgn(
    '1 Video',
    '{0} Videos',
    this.videoList.videos.length);
  this.$edit.find('.js-gallery-edit-all-text').html(total);
  this.$edit.find('.js-gallery-edit-all-wrap').toggle(this.videoList.videos.length > 0);
};

/**
 * Add a video listener
 */
yext.location.VideoGalleryView.prototype.bindAddVideo = function() {
  var self = this;
  this.$element.find('.js-add-video').on('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    self.showAssetSelector();
  });
};

/**
 * Show/bind the asset selector
 */
yext.location.VideoGalleryView.prototype.showAssetSelector = function() {
  var self = this;
  var selectorUsage = goog.module.get('yext.dam.assetselector.usage');
  yext.dam.assetselector.show({
    type: yext.dam.assetselector.types.VIDEO,
    includeUsedAssets: false,
    isSuggestedEditMode: this.getIsSuggestedEditMode(),
    usageType: selectorUsage.forProfileFields(this.fieldName),
  },
  this.fieldName);

  $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
    var video = self.getVideo(asset.videoinfo.id);
    if (video != null) {
      // TRANSLATORS: Error text shown when a user reselects a video
      self.showError(yext.msg('This video has already been selected.'));
      return;
    }
    self.videoList.addVideo(asset, function(video) {
      self.$editWrapper.append(video.$element);
      if (self.locationField) {
        self.locationField.toggleEdit(true);
      }
    });
  });
};

/**
  * Checks for isSuggestedEditMode when locationField might be undefined
  *
  * @return {boolean} Whether it is in suggested edit mode or not
  */
yext.location.VideoGalleryView.prototype.getIsSuggestedEditMode = function() {
  if (this.locationField) {
    return this.locationField.isSuggestEditMode;
  }
  return false;
};

/**
 * Update videos listener
 */
yext.location.VideoGalleryView.prototype.bindUpdateVideos = function() {
  var self = this;
  $(this.videoList).on('updated', function() {
    self.broadcast();
    self.setFieldData();
    self.renderOnUpdate();
  });
};

/**
 * Broadcast updates to the view
 */
yext.location.VideoGalleryView.prototype.broadcast = function() {
  $(this).trigger('update.videoGalleryView');
};

/**
 * Store the video gallery model for restoring on cancel
 */
yext.location.VideoGalleryView.prototype.saveValue = function() {
  this.savedState = this.videoList.getData();
};

/**
 * Reset video gallery view to its saved state
 */
yext.location.VideoGalleryView.prototype.reset = function() {
  this.set(this.savedState);
};

/**
 * Set the state of the video fields
 * @param {!Object} data Plain object version of the field
 */
yext.location.VideoGalleryView.prototype.set = function(data) {
  var self = this;
  this.locationField.field.disableSubmit();
  this.videoList.set(data, function() {
    self.saveValue();
    self.renderDisplay();
    self.renderEdit();
  });
};

/**
 * Show an error when something goes wrong
 *
 * @param {string} msg Error message to display
 */
yext.location.VideoGalleryView.prototype.showError = function(msg) {
  msg = msg || yext.msg('Something went wrong, please reload the page');
  this.$element.find('.js-field-error').html(msg).show();
};

/**
 * Bind location edit page features
 */
yext.location.VideoGalleryView.prototype.locationEditFeatures = function() {
  // If there's no location field the video may be loaded as a suggested edit
  // original location therefore don't bind edit features
  if (!this.locationField) {
    return;
  }
  var self = this;
  $(this).on('update.videoGalleryView', function() {
    self.locationField.field.enableSubmit();
  });

  $(this.locationField.$form).on('save.field', function(e, response) {
    if (response.suggestedEditIds) {
      // Location Edit Field Flow, suggestedEdits should be handled elsewhere now
      self.reset();
    } else if (!response.error) {
      self.set(response.field);
    }
  });

  $(this.locationField).on('toggleFieldEdit', function(e, show) {
    // if no video, dont enter edit mode but open dialog instead
    if (show && self.videoList.isEmpty()
        && self.$element.find('.js-field-error:visible').length === 0) {
      self.showAssetSelector();
      self.locationField.toggleEdit(false);
    }
  });

  this.$element.find('.js-cancel-edit').click(function() {
    self.reset();
  });

  if (this.locationField.$row.data('customFieldId')) {
    $(yext.location.events).on('customFieldTimestampUpdated', function(e, timestamp) {
      self.videoList.timestamp = timestamp;
    });
  }
};

/**
 * Video gallery view sorting listener.
 */
yext.location.VideoGalleryView.prototype.bindSorting = function() {
  var self = this;
  this.$videoList.sortable({
    cancel: 'input,textarea,button,select,option,.js-text-field,.js-pd-indeterminate-message',
    axis: 'y',
    stop: function(e, ui) {
      self.reordered();
      // Note (dwen): Firefox sets top/left to 0 on stop, which causes the
      // image to be misaligned the next time it gets dragged. Explicitly
      // set top/left to auto to fix this.
      ui.item
        .css('top', 'auto')
        .css('left', 'auto');
    },
    containment: this.$edit,
    tolerance: 'pointer',
  });
};

/**
 * Make updates when the gallery is reordered.
 */
yext.location.VideoGalleryView.prototype.reordered = function() {
  this.reordered_ = true;
  this.locationField_ && this.locationField_.field.enableSubmit();

  var self = this;
  var videos = [];
  this.$videoList.find('li').each(function() {
    videos.push(self.getVideo($(this).data('id')));
  });
  this.videoList.videos = videos;
  this.videoList.message('updated');
};

/**
 * Get video model given a video id
 *
 * @param {string} id Video id
 */
yext.location.VideoGalleryView.prototype.getVideo = function(id) {
  for (var i = 0; i < this.videoList.videos.length; i++) {
    if (yext.youtube.parseIdFromUrl(this.videoList.videos[i].video.url) === id) {
      return this.videoList.videos[i];
    }
  }
  return null;
};

/**
 * Select/deselect all videos listener
 */
yext.location.VideoGalleryView.prototype.bindSelectAll = function() {
  var self = this;
  this.$selectAll.on('change', function(e) {
    var $checkboxes = self.$editWrapper.find('input[type=checkbox]');
    var $indeterminate = $checkboxes.filter(function() {
      return $(this).prop('indeterminate');
    });

    // We want to transition from indeterminate to checked
    if ($indeterminate.length > 0) {
      self.$selectAll.prop('checked', true);
    }
    $checkboxes
      .prop('checked', self.$selectAll.prop('checked'))
      .prop('indeterminate', false)
      .change();
    self.broadcast();
  });
};

/**
 * Bind the clear all elided icon
 */
yext.location.VideoGalleryView.prototype.bindClearAllElided = function() {
  this.$editWrapper.on('click', '.video-elided .js-remove-item', function() {
    self.elided = 0;
    $(this).parents('.video-elided').remove();
    self.broadcast();
  });
};

/**
 * Set the hidden input with the value of the field
 */
yext.location.VideoGalleryView.prototype.setFieldData = function() {
  this.$fieldData.val(yext.JSON.stringify(this.getData()));
};

/**
 * Get the field data as JSON
 *
 * @return {!Object} data
 */
yext.location.VideoGalleryView.prototype.getData = function() {
  var self = this;
  var videos = [];
  // filter out unselected inputs
  this.$videoList.find('li').each(function() {
    var $li = $(this);
    var $checkbox = $li.find('input[type=checkbox]');
    if ($checkbox.length === 0 || $checkbox.prop('checked')) {
      var video = self.getVideo($(this).data('id'));
      videos.push(video.getData());
    }
  });

  return {
    'videos': videos,
    'numElided': this.videoList.numElided,
    'timestamp': this.videoList.timestamp,
    'reordered': this.isReorder(),
  };
};

/**
 * Calculate reorder value based on the stored model and the current model.
 *
 * @return {boolean}
 */
yext.location.VideoGalleryView.prototype.isReorder = function() {
  if (!this.videoList || !this.storedModel) {
    return false;
  }

  if (this.videoList.videos.length != this.storedModel.videos.length) {
    return false;
  }
  for (var i = 0; i < this.videoList.videos.length; i++) {
    if (this.videoList.videos[i].url !== this.storedModel.videos[i].url) {
      return true;
    }
  }
  return false;
};
